import {
  trackClickEventProp61,
  trackClickEvent,
} from '@mmt/legacy-commons/Common/utils/OmnitureTrackerUtils';
import { trackPageVisits } from '@mmt/legacy-commons/Common/utils/OmnitureTrackerUtils';
import { trackCovidInfoClicked } from './analytics';

export { trackPageVisits, trackClickEvent, trackClickEventProp61, trackCovidInfoClicked };